module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./RecordListView.js"));
	}, "RelationRecordListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RelationRecordListView!./src/pages/Promote/BusinessHall/AlterRelation/RecordList/RecordListView.js
// module id = 1144
// module chunks = 431